import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import { PickerItem, PickerItemType } from '../picker-item/picker-item.component';
import { AnalyticsService } from '@utils/services/analytics/analytics.service';
import { AdService } from '@lib-modules/ads/services/ad.service';

@Component({
  selector: 'lib-picker-slider',
  templateUrl: './picker-slider.component.html',
  styleUrls: ['./picker-slider.component.scss']
})
export class PickerSliderComponent implements AfterViewInit {

  @Input() items: PickerItem[] = [];
  @Input() colorScheme = ColorScheme.Dark;
  @Input() initialSelect = true;
  @Input() canBeDeselected = false;
  @Input() selectedItem?: PickerItem;
  @Output() onSelect = new EventEmitter<PickerItem>();
  @Output() onDeselect = new EventEmitter<void>();

  constructor(
    private analytics: AnalyticsService,
  ) { }

  public ngAfterViewInit(): void {
    if (this.items.length === 0) {
      return;
    }
    if (this.initialSelect) {
      this.onItemSelected(this.items[0], false);
    }
  }

  public onItemSelected(selectedItem: PickerItem, pageView = true): void {
    if (pageView) {
      this.analytics.sendPageView();
    }
    this.selectedItem = selectedItem;
    this.onSelect.emit(this.selectedItem);
  }

  public onItemDeselected(): void {
    this.analytics.sendPageView();
    this.selectedItem = null;
    this.onDeselect.emit();
  }
}
